import React from 'react'
import { graphql, useLazyLoadQuery } from 'react-relay'
import { useLingui } from '@lingui/react/macro'

import { useParams } from 'react-router-dom'

import { GuildMetadata } from '@newComponents/Guild/GuildMetadata'
import { useScreenMessages } from '@data/i18n'

import { YStack } from 'tamagui'

import { GuildPresentationsScreenUpcomingPresentationsSection } from './GuildPresentationsScreenUpcomingPresentationsSection'
import { GuildPresentationsScreenOtherPresentationsSection } from './GuildPresentationsScreenOtherPresentationsSection'

import { GuildPresentationsScreenQuery } from './__generated__/GuildPresentationsScreenQuery.graphql'

export const GuildPresentationsScreen = () => {
  const { t } = useLingui()
  useScreenMessages((locale) => import(/* webpackChunkName: "locale-guild-presentations-screen-[request]" */ `./locales/${locale}.po`))
  const params = useParams()

  const data = useLazyLoadQuery<GuildPresentationsScreenQuery>(
    graphql`
      query GuildPresentationsScreenQuery($id: String!) {
        nodeBySlugId(id: $id) {
          __typename

          ... on Guild {
            name

            ...GuildMetadata_guild
            ...GuildPresentationsScreenUpcomingPresentationsSection_guild
            ...GuildPresentationsScreenOtherPresentationsSection_guild
          }
        }
      }
    `,
    { id: params.actorId! }
  )

  if (data.nodeBySlugId?.__typename !== 'Guild') {
    return null
  }

  return (
    <>
      <GuildMetadata
        guild={data.nodeBySlugId}
        title={t`${data.nodeBySlugId.name} Presentations`}
      />

      <YStack gap='$5'>
        <GuildPresentationsScreenUpcomingPresentationsSection
          guild={data.nodeBySlugId}
        />

        <GuildPresentationsScreenOtherPresentationsSection
          guild={data.nodeBySlugId}
        />
      </YStack>
    </>
  )
}

export default GuildPresentationsScreen
